import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fund-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "table-container"
}

import MarketTypeTab from '@/components/holdings/MarketTypeTab.vue'
import TableEmpty from '@/components/holdings/TableEmpty.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { formatThousandsKeepDecimal } from '@/utils/num_format'
import useFundAndBond from '@/hooks/holdings/useFundAndBond'


export default /*@__PURE__*/_defineComponent({
  __name: 'FundDetail',
  setup(__props) {

const store = useStore()

const marketTypeList = ref([
  {
    label: '港元账户',
    value: 'HKD'
  },
  {
    label: '美元账户',
    value: 'USD'
  }
])

const currencyList = ref([
  {
    label: '港元',
    value: 'HKD'
  },
  {
    label: '美元',
    value: 'USD'
  }
])
// 过滤出当前账户类型的持仓
const fundPosPageList = computed(() => store.state.holdings.fundPosPageList.rows.filter(item => item.moneyType === store.state.holdings.marketTypeActive.value))

const assetsInfo = computed(() => {
  const mv = store.state.holdings.fundPosPageList.mv.find(item => item.ccy === store.state.holdings.marketTypeActive.value)
  const value = mv ? formatThousandsKeepDecimal(mv.value, 2) : '--'
  const currencyText= currencyList.value.find(item => item.value === store.state.holdings.marketTypeActive.value)?.label
  return [
    {
      label: `资产净值(${currencyText})`,
      value
    }
  ]
})

const { queryFundAndBondData, loading } = useFundAndBond({ exchangeType: 'FUND' })

onMounted(() => {
  queryFundAndBondData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MarketTypeTab, {
      marketTypeList: marketTypeList.value,
      assetsInfo: assetsInfo.value
    }, null, 8, ["marketTypeList", "assetsInfo"]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "持仓", -1)),
    (_unref(loading) || fundPosPageList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: fundPosPageList.value,
            "show-overflow-tooltip": "",
            "header-cell-class-name": "fund-detail-table-header-cell",
            "row-class-name": "fund-detail-table-row",
            style: {"width":"100%"},
            "max-height": "300"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "stockCode",
                label: "名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "marketValueDisplay",
                label: "总市值"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(loading)]
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tips" }, " 注：如阁下需交易基金，请致电+852 2153 3838，与我们联络。 ", -1))
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !fundPosPageList.value.length)
      ? (_openBlock(), _createBlock(TableEmpty, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})